import api from './api';
import { normalizeListResponse } from '../utils/listResponse';

export type LynkPaymentEventState = 'all' | 'applied' | 'failed';

export interface LynkPaymentEvent {
  id: string;
  message_id: string;
  ref_id: string;
  event: string;
  customer_email: string;
  item_title: string;
  tier?: 'basic' | 'plus' | null;
  amount_raw: string;
  months_added: number;
  company_id?: string | null;
  company_name?: string | null;
  applied: boolean;
  apply_error?: string | null;
  raw_payload: unknown;
  signature: string;
  received_at: string;
}

export interface ListLynkPaymentEventsParams {
  page?: number;
  size?: number;
  search?: string;
  state?: LynkPaymentEventState;
}

export const lynkPaymentEventService = {
  list: async (
    params: ListLynkPaymentEventsParams = {},
  ): Promise<{ data: LynkPaymentEvent[]; total: number }> => {
    const { page = 1, size = 25, search, state = 'all' } = params;
    const query = new URLSearchParams();
    query.set('limit', String(size));
    query.set('offset', String((page - 1) * size));
    query.set('state', state);
    if (search?.trim()) query.set('search', search.trim());
    const response = await api.get(`/admin/lynk/payment-events?${query.toString()}`);
    return normalizeListResponse<LynkPaymentEvent>(response.data);
  },
};
